import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useAuthorizationService } from 'src/apis/authorization-service/use-authorization-service';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageSpinner } from 'src/components/spinner-container';
import { CreatePermissionGroup } from 'src/pages/settings/permission-groups/create';
import { PermissionGroupsDetails } from 'src/pages/settings/permission-groups/details';
import { EditPermissionGroup } from 'src/pages/settings/permission-groups/edit';
import { PermissionGroupsOverview } from 'src/pages/settings/permission-groups/overview';
import { Forbidden } from 'src/utils/errors';

export const PermissionGroups: FC = () => {
  const authorizationService = useAuthorizationService();

  if (!authorizationService) throw new Forbidden();
  if (!authorizationService.response) return <PageSpinner />;

  return (
    <Switch>
      <Route path="/settings/permission-groups" exact>
        <PermissionGroupsOverview authorizationService={authorizationService} />
      </Route>

      <Route path="/settings/permission-groups/create" exact>
        <CreatePermissionGroup authorizationService={authorizationService} />
      </Route>

      <Route path="/settings/permission-groups/:permissionGroupId" exact>
        <PermissionGroupsDetails authorizationService={authorizationService} />
      </Route>

      <Route path="/settings/permission-groups/:permissionGroupId/edit" exact>
        <EditPermissionGroup authorizationService={authorizationService} />
      </Route>

      <Route>
        <ThrowNotFound />
      </Route>
    </Switch>
  );
};
